import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Subtitle } from '@components/Styled';
import { CircleWrapper, DataContainer, TitleCard, TitleContainer, TotalTitle } from './SummaryCard.style';
const Header = ({ children }) => (_jsx(TitleContainer, { children: children }));
const Title = ({ children, number }) => (_jsxs(TitleCard, { children: [number !== undefined && (_jsx(CircleWrapper, { children: number })), children && (_jsx(Subtitle, { level: "3", children: children }))] }));
const TitleAmount = ({ children, color }) => (_jsx("div", { children: _jsx(DataContainer, { children: _jsx(Subtitle, { level: "3", children: _jsx(TotalTitle, { style: { color }, children: children }) }) }) }));
Header.Title = Title;
Header.TitleAmount = TitleAmount;
export default Header;
